import { i18n } from "@dehub/theme";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function effectiveOrderStatus(order: any): string {
  const orderStatus = String(order?.orderStatus ?? "").toUpperCase();
  if (orderStatus !== "AUTHORIZED" && orderStatus !== "APPROVED") return orderStatus;
  const dn = order?.deliveryNote;
  const dnStatus = String(dn?.deliveryNoteStatus ?? "").toUpperCase();
  const delivered = Boolean(order?.deliveredDate);
  if (dnStatus === "DELIVERED" || delivered) return "DELIVERED";
  if (dnStatus === "DELIVERING") return "DELIVERING";
  if (dnStatus === "ASSIGNED" || dnStatus === "PENDING_HANDOVER" || dnStatus === "LOADED") {
    return "PREPARING";
  }
  return orderStatus;
}

// Mantine CSS variable colors so StatusBadge's color-mix()/border work correctly.
const STATUS_UI: Record<string, { labelKey: string; color: string }> = {
  DRAFT          : { labelKey: "DRAFT", color: "var(--mantine-color-gray-6)" },
  REGISTERED     : { labelKey: "REGISTERED", color: "var(--mantine-color-blue-6)" },
  REVIEW_REJECTED: { labelKey: "REVIEW_REJECTED", color: "var(--mantine-color-red-6)" },
  REVIEWED       : { labelKey: "REVIEWED", color: "var(--mantine-color-orange-6)" },
  APPROVED       : { labelKey: "APPROVED", color: "var(--mantine-color-green-6)" },
  AUTHORIZED     : { labelKey: "AUTHORIZED", color: "var(--mantine-color-green-6)" },
  PREPARING      : { labelKey: "PREPARING", color: "var(--mantine-color-violet-6)" },
  DELIVERING     : { labelKey: "DELIVERING", color: "var(--mantine-color-blue-6)" },
  DELIVERED      : { labelKey: "DELIVERED", color: "var(--mantine-color-teal-6)" },
  CLOSED         : { labelKey: "CLOSED", color: "var(--mantine-color-green-6)" },
  CANCELED       : { labelKey: "CANCELED", color: "var(--mantine-color-red-6)" },
  AUTO_CANCELED  : { labelKey: "CANCELED", color: "var(--mantine-color-red-6)" },
  REJECTED       : { labelKey: "REJECTED", color: "var(--mantine-color-red-6)" },
};

export function orderStatusUi(status: string): { label: string; color: string } {
  const s = String(status ?? "").toUpperCase();
  const entry = STATUS_UI[s];
  if (!entry) return { label: s || "—", color: "var(--mantine-color-gray-6)" };
  return { label: i18n.t(`order:orderStatus.${entry.labelKey}`), color: entry.color };
}
